import { render, staticRenderFns } from "./ReportsRentability.vue?vue&type=template&id=5f5e77e9&"
import script from "./ReportsRentability.vue?vue&type=script&lang=js&"
export * from "./ReportsRentability.vue?vue&type=script&lang=js&"
import style0 from "./ReportsRentability.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports